import { atom } from 'recoil';

export interface WalkthroughChatPrefill {
  text: string;
  version: number;
}

export const walkthroughChatPrefillAtom = atom<WalkthroughChatPrefill | null>({
  key: 'walkthroughChatPrefill',
  default: null,
});
